import { SgWebHttpClient, RequestMethod } from '@ds/ng-wt-helpers/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { all as arrayMerge } from 'deepmerge';

export interface ITranslationResource {
  path: string;
  extn?: string;
}

export class CompositeTranslateLoader implements TranslocoLoader {
  constructor(
    private http: SgWebHttpClient,
    private resources: ITranslationResource[],
  ) { }

  getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map(resource => {
      const path = resource.path + lang + (resource.extn || '');
      return this.http.restAPIObservable<Translation>(RequestMethod.GET, path)
        .pipe(catchError(res => {
          console.error("Could not find the translation file:", path);
          return of({});
        }));
    });
    return forkJoin(requests).pipe(map(response => arrayMerge(response)));
  }
}
